module.exports = __webpack_public_path__ + "static/media/ddddd.ecb82a93.png";